// AutoMapper
import "reflect-metadata";
import {
    AutoMapper,
    ProfileBase,
    mapFrom,
    Mapper,
    convertUsing,
    Converter
} from "@nartc/automapper";

// Models
import { ContactPersonDto } from 'app/_mapper/contactperson.dto';
import { ContactPersonVm } from 'app/_mapper/contactperson.vm';

export class ContactPersonProfile extends ProfileBase {
    constructor(mapper: AutoMapper) {
        super();

        mapper
            .createMap(ContactPersonDto, ContactPersonVm);
            
        mapper
            .createMap(ContactPersonVm, ContactPersonDto)
            .forMember(
                d => d.address,
                mapFrom(s => s.cpeAddress))
            .forMember(
                d => d.city,
                mapFrom(s => s.cpeCity))
            .forMember(
                d => d.countryId,
                mapFrom(s => s.cpeCountry.id))
            .forMember(
                d => d.email,
                mapFrom(s => s.cpeEmail))
            .forMember(
                d => d.firstName,
                mapFrom(s => s.cpeFirstName))
            .forMember(
                d => d.genderId,
                mapFrom(s => s.cpeGender.id))
            .forMember(
                d => d.lastName,
                mapFrom(s => s.cpeLastName))
                .forMember(
                    d => d.maidenName,
                    mapFrom(s => s.cpeMaidenName))
            .forMember(
                d => d.phoneNumber,
                mapFrom(s => s.cpePhoneNumber))
            .forMember(
                d => d.relationshipId,
                mapFrom(s => s.cpeRelationship.prId))
            .forMember(
                d => d.remarks,
                mapFrom(s => s.cpeRemarks))
            ;
    }
}
